import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static values = {
    categories: Array,
    series: Array
  }

  connect() {
    const options = {
      chart: {
        height: 320,
        type: "area",
        fontFamily: "Inter, sans-serif",
        toolbar: { show: false },
      },
      series: [{
        name: this.element.dataset.chartLabel || "Sales",
        data: this.seriesValue,
        color: "#1C64F2",
      }],
      xaxis: {
        categories: this.categoriesValue,
        labels: {
          style: { cssClass: "text-xs text-body" },
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      yaxis: {
        labels: {
          style: { cssClass: "text-xs text-body" },
          formatter: (val) => val.toFixed(0),
        },
      },
      fill: {
        type: "gradient",
        gradient: { opacityFrom: 0.55, opacityTo: 0, shade: "#1C64F2" },
      },
      stroke: { width: 4, curve: "smooth" },
      dataLabels: { enabled: false },
      grid: {
        strokeDashArray: 4,
        padding: { left: 2, right: 2 },
      },
      tooltip: {
        y: { formatter: (val) => `${val} lei` },
      },
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }
}
